import { useEffect, useState } from 'react'

import DashboardTopBar from './DashboardTopBar'
import DashboardStageHistory from './DashboardScreens/DashboardStageHistory'
import DashboardSidePanel from './DashboardSidePanel'
import DashboardHeader from './DashboardHeader'
import DashboardDocumentsCenter from './DashboardScreens/DashboardDocumentCenter/DashboardDocumentsCenter'
import DashboardResourceCenter from './DashboardScreens/DashboardResourceCenter'
import DashboardQA from './DashboardScreens/DashboardQA'
import DashboardContactUs from './DashboardScreens/DashboardContactUs'
import { refreshAccessToken, shouldShowChartConnect, shouldShowChartInstantCalculation, shouldShowDocuments, shouldShowTaxStatusToChart, 
         showCollectionsWindow, showPendingCalcWindow, showRefundCalculatedWindow } from '../../utilities/extensions'
import DashboardDocumentsHeader from './DashboardScreens/DashboardDocumentsHeader'
import { company, customerData } from '../../utilities/CustomerData'
import { RefundCalculatedWindow } from '../Payment/RefundCalculatedWindow'
import { useLocation, useNavigate } from 'react-router-dom'
import DashboardReferAFriend from './DashboardScreens/DashboardReferAFriend'
import DashboardChangeDays from './DashboardScreens/DashboardChangeDays'
import MobileSideBar from '../../utilities/MobileSideBar'
import { DashboardDiscountCode } from './DashboardScreens/DashboardDiscountCode'
import { WelcomeModal } from '../WelcomeModal'
import { CollectionsWindow } from './DashboardScreens/CollectionsWindow'
import { DashboardChartConnect } from './DashboardScreens/DashboardChartConnect'
import { DashboardChartInstantCalculation } from './DashboardScreens/DashboardChartInstantCalculation'
import { DashboardResetAgreement } from './DashboardResetAgreement'
import { DashboardReconnectChart } from './DashboardScreens/DashboardReconnectChart'
import { apiURL } from '../../utilities/URLs'
import { DashboardFailedBankValidation } from './DashboardScreens/DashboardFailedBankValidation'
import { DashboardBankVerified } from './DashboardScreens/DasboardBankVerified'
import { DashboardESign } from './DashboardScreens/DashboardESign'
import { DashboardIssueWithDocs } from './DashboardScreens/DashboardIssueWithDocs'
import { DashboardResyncIDME } from './DashboardScreens/DashboardResyncIDME'
import { DashboardInstantOffline } from './DashboardScreens/DashboardInstantOffline'
import { DashboardPendingBank } from './DashboardScreens/DashboardPendingBank'
import { DashboardResign } from './DashboardScreens/DashboardResign'
import { DashboardSignAffidavit } from './DashboardScreens/DashboardSignAffidavit'
import { DashboardPendingCals } from './DashboardScreens/DashboardPendingCalcs'
import { DashboardDocsSentToOffice } from './DashboardScreens/DasboardDocsSentToOffice'
import { DashboardInReview } from './DashboardScreens/DashboardInReview'
import { DashboardDocsSentToIRS } from './DashboardScreens/DashboardDocsSentToIRS'
import { DashboardDocsReceivedAtIRS } from './DashboardScreens/DashboardDocsReceivedAtIRS'
import { DashboardSyncBankAccount } from './DashboardScreens/DashboardSyncNewBankAccount'
import DashboardUpdateTranscripts from './DashboardScreens/DashboardUpdateTranscripts'
import DashboardUpdateBanking from './DashboardScreens/DashboardUpdateBanking'
import DashboardCompleteIDme from './DashboardScreens/DashboardCompleteIDMe'
import DashboardSignTOS from './DashboardScreens/DashboardSignTOS'
import DashboardProgress from './DashboardScreens/DashboardProgress'
import DashboardFilingTimer from './DashboardScreens/DashboardFilingTimer'
import DashboardPastDeadline from './DashboardScreens/DashboardPastDeadline'
import DashboardManualIDReview from './DashboardScreens/DashboardManaulIDReview'
import DashboardUploadReviewID from './DashboardScreens/DashboardUploadReviewID'
import { DateTime } from 'luxon'
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton } from 'react-share'
import DashboardShareRefund from './DashboardScreens/DashboardShareRefund'

export default function Dashboard({ showMobileSideBar, setShowMobileSideBar, setShowNavBar, setCheckForCalculation }) {
  const navigate = useNavigate()
  const location = useLocation()
  const currentActiveTab = location.state ? location.state.activeTab : 0

  const [activeTab, setActiveTab] = useState(-1)
  const [canInstantCalc, setCanInstantCalc] = useState(false)
  const [canAF, setCanAF] = useState(true)
  const [checkedInstantCalc, setCheckedInstantCalc] = useState(false)
  const [isPreQualified, setIsPreQualified] = useState(shouldShowChartConnect())
  const [isTaxStatus, setIsTaxStatus] = useState(shouldShowTaxStatusToChart(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [isChartInstantCalc, setIsChartInstantCalc] = useState(shouldShowChartInstantCalculation(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [hasDocuments, setHasDocuments] = useState(shouldShowDocuments(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [isPendingCalc, setIsPendingCalc] = useState(showPendingCalcWindow(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [hasRefund, setHasRefund] = useState(showRefundCalculatedWindow(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [isCollections, setIsCollections] = useState(showCollectionsWindow(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [resetAgreement, setResetAgreement] = useState(customerData.customerPlaidAgreement.resetAgreement)
  const [invalid8821, setInvalid821] = useState(customerData.customerLeadData.leadContact.chartStatus === 'REJECTED' || customerData.customerLeadData.leadStage.leadStageId === 'f694c99f-93d8-450b-a947-0acb7c7ac4b3')
  const [failedBankValidation, setFailedBankValidattion] = useState(customerData.customerLeadData.leadStage.leadStageId === '715b25ed-9768-4a95-8e42-0d8fe4076fa1')
  const [failedToCreateBankApplication, setFailedToCreateBankApplication] = useState(customerData.customerLeadData.leadStage.leadStageId === '0e2e7847-c112-4f15-b17f-cdf2622b4c91')
  const [bankValidated, setBankValidated] = useState(customerData.customerLeadData.leadStage.leadStageId === '515d1c17-d315-4e32-ac0f-f3aeb38e7080')
  const [issueWithDocs, setIssueWithDocs] = useState(customerData.customerLeadData.leadStage.leadStageId === 'c0dc31c8-10be-4dc0-9796-a80ca8b4bbb4')
  const [canESign, setCanESign] = useState(customerData.customerLeadData.leadStage.leadStageId === 'c82cc1f9-a5a1-46d5-bd05-23dad9a4878b')
  const [isPendingBank, setIsPendingBank] = useState(customerData.customerLeadData.leadStage.leadStageId === '5eed0588-1ae4-4690-8af9-e5aaf2fe97e5')
  const [docsMailed, setDocsMailed] = useState(customerData.customerLeadData.leadStage.leadStageId === '89073790-fb45-4e58-adfe-20c7cb6c0e17')
  const [docsReceived, setDocsReceived] = useState(customerData.customerLeadData.leadStage.leadStageId === '0a0c959f-7286-4f8f-97c3-20b8e8b873cd')
  const [resign, setResign] = useState(customerData.customerLeadData.leadStage.leadStageId === '34eaa794-f482-4112-9bf8-1f37d2029128')
  const [signAffidavit, setSignAffidavit] = useState(customerData.customerLeadData.leadStage.leadStageId === '4aa5f65b-4474-4d2e-9a0c-f84bd305aff6')
  const [showWelcomeModal, setShowWelcomeModal] = useState(false)
  const [inReview, setInReview] = useState(customerData.customerLeadData.leadStage.leadStageId === '0e2e7847-c112-4f15-b17f-cdf2622b4c91')
  const [docsSentToIRS, setDocsSentToIRS] = useState(customerData.customerLeadData.leadStage.leadStageId === '9222ce06-f740-467d-a86f-bc782a1d3887')
  const [docsReceivedAtIRS, setDocsReceivedAtIRS] = useState(customerData.customerLeadData.leadStage.leadStageId === 'e36b27ed-74f2-4733-83bc-a4d6bc5d0915')
  const [syncNewBankAccount, setSyncNewBankAccount] = useState(customerData.customerLeadData.leadStage.leadStageId === '085830f0-9598-47ff-bf2c-d0b7bd4deabc')
  const [uploadID, setUploadID] = useState(customerData.customerLeadData.leadStage.leadStageId === '54f7e7f4-6f4a-4a8f-95bb-414657a89404')
  const [issueResolved, setIssueResolved] = useState(customerData.customerLeadData.leadStage.leadStageId === 'd23bdf4e-886f-493a-b628-8c9a1efb398b')
  const [updateTranscripts, setUpdateTranscripts] = useState(customerData.customerLeadData.leadStage.leadStageId === '1eb589fb-460d-4d06-b374-dd10c1fdaa52')
  const [updateBanking, setUpdateBanking] = useState(customerData.customerLeadData.leadStage.leadStageId === 'c9d17db5-8581-441f-af7d-3dcc0caae173')
  const [signTOS, setSignTOS] = useState(customerData.customerLeadData.leadStage.leadStageId === '0e2e7847-c112-4f15-b17f-cdf2622b4c91' && !customerData.customerTOSData.tosId)
  const [noFiledDate, setNoFiledDate] = useState(customerData.customerLeadData.leadStage.leadStageId === '3b4e1465-5211-4ac0-a215-371db7a2dd37')
  const [pastDeadline, setPastDeadline] = useState(customerData.customerLeadData.leadStage.leadStageId === 'eb56d073-2fff-4055-82b3-c0939cff5815')
  const [manualIDReview, setManualIDReview] = useState(customerData.customerLeadData.leadStage.leadStageId === '4fbbed3e-41d7-40e6-8e96-24f01e3925a4')
  const [uploadReviewID, setUploadReviewID] = useState(customerData.customerLeadData.leadStage.leadStageId === 'a8670a9f-cbd2-4d61-97f0-4008e9ff8e7b')
  const [pastAFDeadline, setPastAFDeadline] = useState(customerData.customerLeadData.leadStage.leadStageId === 'f96797f5-64bd-443a-ad49-dc0abed71e07')
  const [hasTime, setHasTime] = useState(false)
  const [customerQRCode, setCustomerQRCode] = useState('')
  const [customerStageDetails, setCustomerStageDetails] = useState(customerData.getCustomerStageName())
  const [connectIDme, setConnectIDme] = useState(localStorage.getItem('idme'))

  useEffect(() => {
    const handleCheckInstantCalc = async () => {
      const checkInstantCalcResponse = await fetch(`${apiURL}/api/checkCanInstantCalc`, {
        headers: {
          'Authorization': customerData.accessToken
        }
      })
      const checkInstantCalcData = await checkInstantCalcResponse.json()
      if (checkInstantCalcData.response.error) {
        if (checkInstantCalcData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleCheckInstantCalc() : navigate('/', { state: { expired: true } })
        } else
          console.error(checkInstantCalcData.response.error)
      } else
        setCanInstantCalc(checkInstantCalcData.response.canRun)

      setCheckedInstantCalc(true)
    }

    const handleCheckAF = async () => {
      const checkInstantCalcResponse = await fetch(`${apiURL}/api/checkCanAF`, {
        headers: {
          'Authorization': customerData.accessToken
        }
      })
      const checkInstantCalcData = await checkInstantCalcResponse.json()
      if (checkInstantCalcData.response.error) {
        if (checkInstantCalcData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleCheckInstantCalc() : navigate('/', { state: { expired: true } })
        } else
          console.error(checkInstantCalcData.response.error)
      } else
        setCanAF(checkInstantCalcData.response.canRun)
    }

    handleCheckInstantCalc()
    handleCheckAF()
    setShowNavBar(true)
    document.title = `${company.companyName} | Stage History`
    if (currentActiveTab)
      setActiveTab(currentActiveTab)

    setShowWelcomeModal(customerData.customerCreatedAccount)
  }, [])

  const handleGetQRCode = async () => {
    const s3Response = await fetch(`${apiURL}/api/generateS3URL?url=${encodeURIComponent(customerData.customerQRCodeData.qrCodeURL)}`, {
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const s3Data = await s3Response.json()
    if(s3Data.response.error) {
      if(s3Data.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleGetQRCode() : navigate('/', { state: { expired: true } })
      } else
        console.error(s3Data.response.error)
    } else
      setCustomerQRCode(s3Data.response.s3Url)
  }

  useEffect(() => {
    handleGetQRCode()
  
    const filingDateStr = (customerData.customerLeadData.leadContact.filingDate ? customerData.customerLeadData.leadContact.filingDate : customerData.customerDocuments.filingDate) || '2022-04-18'
    const filingDate = DateTime.fromISO(filingDateStr, { zone: 'America/New_York' })
    const today = DateTime.now().setZone('America/New_York').startOf('day')
  
    let deadline
  
    if (filingDate < DateTime.fromISO('2022-04-18', { zone: 'America/New_York' })) {
      deadline = DateTime.fromISO('2025-04-18', { zone: 'America/New_York' })
    } else if (filingDate > DateTime.fromISO('2022-10-15', { zone: 'America/New_York' })) {
      deadline = DateTime.fromISO('2025-10-15', { zone: 'America/New_York' })
    } else {
      deadline = DateTime.fromObject(
        { year: 2025, month: filingDate.month, day: filingDate.day },
        { zone: 'America/New_York' }
      )
    }
  
    setHasTime(today <= deadline)
  }, [])

  return (
    <>
      <div className='flex flex-row font-mont justify-center bg-slate-200 min-h-[calc(100vh-72px)]'>
        <div className='flex max-sm:flex-col flex-row flex-1 max-sm:items-center items-start font-mont max-w-[1250px] gap-10 lg:h-fit mt-4 mb-4'>
          <DashboardSidePanel
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <div className='flex flex-col items-center h-full w-full'>
            {customerData.customerLeadData.leadType === 'Leads' && (
              <DashboardProgress />
            )}
            <DashboardTopBar />
            {customerData.customerLeadData.leadType === 'Deals' && (
              <DashboardFilingTimer />
            )}
            {(activeTab === 0 || activeTab === -1) && (
              (!invalid8821 && !isTaxStatus && !connectIDme && !customerData.customerLeadData.leadStage.leadStageName.startsWith('AF') || (customerData.customerLeadData.leadStage.leadStageName.startsWith('AF') && canAF) ? (
                <>
                {isPreQualified && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                      </div>
                    )}
                    <DashboardChartConnect setShowNavBar={setShowNavBar} />
                  </div>
                )}
                
                {(isChartInstantCalc && canInstantCalc) && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                      </div>
                    )}
                    <DashboardChartInstantCalculation
                      setIsChartInstantCalc={setIsChartInstantCalc}
                      setCheckForCalculation={setCheckForCalculation}
                    />
                  </div>
                )}
                {(!canInstantCalc && checkedInstantCalc) && (
                  <DashboardInstantOffline />
                )}
                {isPendingCalc && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                  {window.innerWidth <= 768 && (
                    <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                      <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                      <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                    </div>
                  )}
                  <DashboardPendingCals />
                </div>
                )}
                {hasRefund && (
                  hasTime ? (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <RefundCalculatedWindow />
                    </div>
                  ) : (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardPastDeadline />
                    </div>
                  )
                  
                )}
                {isPendingBank && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                      </div>
                    )}
                    <DashboardPendingBank />
                  </div>
                )}
                {failedBankValidation && (
                  customerData.customerVerificationData.customerId ? (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                        </div>
                      )}
                      <DashboardFailedBankValidation />
                    </div>
                  ) : (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                        </div>
                      )}
                      <DashboardResyncIDME />
                    </div>
                  )
                )}
                {(failedToCreateBankApplication && !customerData.customerVerificationData.customerId) && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                      </div>
                    )}
                    <DashboardResyncIDME />
                  </div>
                )}
                {bankValidated && (
                  customerData.customerVerificationData.customerId ? (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardBankVerified />
                    </div>
                  ) : (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                        </div>
                      )}
                      <DashboardResyncIDME />
                    </div>
                  )
                )}
                {hasDocuments && (
                  customerData.customerLeadData.leadStage.leadStageId === '04144458-31da-4f86-be7b-69051d6c1cc9' ? (
                    customerData.customerVerificationData.customerId ? (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        <div className='max-sm:w-11/12 shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
                          <p className='font-bold text-2xl text-[#646464]'>UPS Store QR Code</p>
                          <img className='w-44' src={customerQRCode} />
                        </div>
                        <DashboardDocumentsHeader />
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                          </div>
                        )}
                        <DashboardResyncIDME />
                      </div>
                    )
                  ) : (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardDocumentsHeader />
                    </div>
                  )
                )}
                {docsMailed && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                      </div>
                    )}
                    <DashboardDocsSentToOffice />
                  </div>
                )}
                {docsReceived && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                  {window.innerWidth <= 768 && (
                    <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                      <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                      <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                    </div>
                  )}
                  <DashboardDocsSentToOffice />
                </div>
                )}
                {issueWithDocs && (
                  customerData.customerVerificationData.customerId ? (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardIssueWithDocs />
                    </div>
                  ) : (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                        </div>
                      )}
                      <DashboardResyncIDME />
                    </div>
                  )
                )}
                {canESign && (
                  customerData.customerVerificationData.customerId ? (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                      </div>
                      )}
                      <DashboardESign />
                    </div>
                  ) : (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                        </div>
                      )}
                      <DashboardResyncIDME />
                    </div>
                  )
                )}
                {docsSentToIRS && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                      </div>
                    )}
                    <DashboardDocsSentToIRS />
                  </div>
                )}
                {docsReceivedAtIRS && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                      </div>
                    )}
                    <DashboardDocsReceivedAtIRS />
                  </div>
                )}
                {inReview && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                      </div>
                    )}
                    <DashboardInReview />
                  </div>
                )}
                {isCollections && (
                  <CollectionsWindow />
                )}
                {resetAgreement && (
                  <DashboardResetAgreement />
                )}
                {resign && (
                  customerData.customerVerificationData.customerId ? (
                    <DashboardResign />
                  ) : (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                        </div>
                      )}
                      <DashboardResyncIDME />
                    </div>
                  )
                )}
                {signAffidavit && (
                  customerData.customerVerificationData.customerId ? (
                    <DashboardSignAffidavit />
                  ) : (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                        </div>
                      )}
                      <DashboardResyncIDME />
                    </div>
                  )
                )}
                {syncNewBankAccount && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                  {window.innerWidth <= 768 && (
                    <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                      <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                      <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                    </div>
                  )}
                  <DashboardSyncBankAccount />
                </div>
                )}
                {uploadID && (
                  customerData.customerVerificationData.customerId ? (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardUploadReviewID
                        setUploadReviewID={setUploadReviewID}
                        setManualIDReview={setManualIDReview}
                      />
                    </div>
                  ) : (
                    <DashboardResyncIDME />
                  )
                )}
                {issueResolved && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className='text-[#FF8C00] text-center font-bold text-3xl'>Issue Resolved</p>
                      </div>
                    )}
                    <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
                      <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
                      <p className='font-bold text-xl text-[#646464] text-center'>Our team is working to confirm that your issue has been resolved and are ready to continue your application.</p>
                    </div>
                  </div>
                )}
                {updateTranscripts && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className='text-[#FF8C00] text-center font-bold text-3xl'>Update Transcripts</p>
                      </div>
                    )}
                    <DashboardUpdateTranscripts setShowNavBar={setShowNavBar} />
                  </div>
                )}
                {updateBanking && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className='text-[#FF8C00] text-center font-bold text-3xl'>Update Banking</p>
                      </div>
                    )}
                    <DashboardUpdateBanking setShowNavBar={setShowNavBar} />
                  </div>
                )}
                {signTOS && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                  {window.innerWidth <= 768 && (
                    <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                      <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                      <p className='text-[#FF8C00] text-center font-bold text-3xl'>Sign TOS</p>
                    </div>
                  )}
                  <DashboardSignTOS />
                </div>
                )}
                {noFiledDate && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                      </div>
                    )}
                    <DashboardDocumentsHeader />
                  </div>
                )}
                {pastDeadline && (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                      </div>
                    )}
                    <DashboardPastDeadline />
                  </div>
                )}
                {pastAFDeadline && (
                  !hasTime ? (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardPastDeadline />
                    </div>
                  ) : (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <RefundCalculatedWindow />
                    </div>
                  )
                )}
                {manualIDReview && (
                  customerData.customerVerificationData.customerId ? (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardManualIDReview />
                    </div>
                  ) : (
                    <DashboardResyncIDME />
                  )
                )}
                {uploadReviewID && (
                  customerData.customerVerificationData.customerId ? (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardUploadReviewID
                        setUploadReviewID={setUploadReviewID}
                        setManualIDReview={setManualIDReview}
                      />
                    </div>
                  ) : (
                    <DashboardResyncIDME />
                  )
                )}
                </>
              ) : (
                invalid8821 ? (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                      </div>
                    )}
                    <DashboardReconnectChart setShowNavBar={setShowNavBar} />
                  </div>
                ) : connectIDme ? (
                  !connectIDme ? (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardChartConnect setShowNavBar={setShowNavBar} />
                    </div>
                  ) : (
                    <DashboardCompleteIDme />
                  )
                ) : (
                  <div className='lg:w-full w-11/12 flex flex-col gap-4 mt-4'>
                    <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
                      <div className='w-full flex flex-col items-center'>
                        <div className='w-full flex flex-col items-center gap-4'>
                          <p className='font-bold text-2xl'>Maintenance</p>
                          <p>We are undergoing some maintenance, and will be back up in no time!</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              ))
            )}
            {customerData.customerLeadData.leadType === 'Deals' && (
              <DashboardShareRefund />
            )}
            {activeTab !== -1 && (
              <DashboardHeader
                activeTab={activeTab}
              />
            )}
            {activeTab === 0 ? (
              <DashboardStageHistory />
            ) : activeTab === 1 ? (
              <DashboardDocumentsCenter />
            ) : activeTab === 2 ? (
              <DashboardResourceCenter />
            ) : activeTab === 3 ? (
              <DashboardQA />
            ) : activeTab === 4 ? (
              <DashboardContactUs />
            ) : activeTab === 5 ? (
              <DashboardReferAFriend />
            ) : activeTab === 6 ? (
              <DashboardChangeDays />
            ) : activeTab === 7 ? (
              <DashboardDiscountCode />
            ) : (
              <></>
            )}
          </div>
        </div>
        <MobileSideBar showMobileSideBar={showMobileSideBar} setShowMobileSideBar={setShowMobileSideBar} activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
      {showWelcomeModal && (
        <WelcomeModal setShowWelcomeModal={setShowWelcomeModal} />
      )}
    </>
  )
}